module.exports = __webpack_public_path__ + "images/emoji/slot_machine.f02cd0f479ce4e4259f9.png";